import { CONFIG } from 'constants/configConstants';
import { call, put, takeLatest } from 'redux-saga/effects';
import ConfigAction, { ConfigTypes } from 'redux/actions/configAction';
import { AppService } from 'services';
import BaseAction from '../actions/baseAction';
import { filterDataByArrayConfig } from 'utils/function';
import { configWithGeneralLabel, configWithStaticPageLabel } from 'utils/saga';

export function* getGeneralConfig(): any {
  try {
    const result = yield call(AppService.getListConfigAzure, CONFIG.UPTIME_GENERAL.LABEL);

    const data = filterDataByArrayConfig(result, configWithGeneralLabel);
    
    const newData = data.map((item: any) => {
      if (item.key === CONFIG.UPTIME_PCL_SETTING.KEY) {
        const pclConfig = item?.value;
        const { pickupConfig } = pclConfig;
        return {
          pclConfig: {
            ...pclConfig,
            pickupConfig: !!pickupConfig ? {
              isTypePickupLocation: pickupConfig?.type?.toUpperCase() === CONFIG.PICKUP_LOCATION,
              defaultCountry: pickupConfig?.defaultCountry,
              verbiageConfig: pickupConfig?.verbiageConfig,
              autoWBSCode: pickupConfig?.autoPopulate?.wbsCode,
              autoPhoneNumber: pickupConfig?.autoPopulate?.phoneNumber,
            } : {}
          },
        };
      }
      return item?.value;
    });

    if (!!newData && newData?.length > 0) {
      for (const item of newData) {
        yield put(ConfigAction.getGeneralConfigSuccess(item));
      }
    }
  } catch (error) {
    yield put(ConfigAction.getGeneralConfigSuccess({"isOutage":true}));
    yield put(
      BaseAction.errorHandling({
        message: `GET_LIST_CONFIGURATION ${error}`,
      }),
    );
  }
}

export function* getNotificationConfig(): any {
  try {
    const result = yield call(AppService.getValueConfigAzure, CONFIG.NOTIFICATION.KEY, CONFIG.NOTIFICATION.LABEL);
    if (result) {
      yield put(ConfigAction.getNotificationConfigSuccess(result));
    }
  } catch (error) {
    yield put(BaseAction.errorHandling({
      message: `GET_NOTIFICATION_CONFIG ${error}`
    }));
  }
}

export function* getStaticPageConfig(): any {
  try {
    const result = yield call(AppService.getListConfigAzure, CONFIG.UPTIME_STATIC_LANDING_PAGE.LABEL);
    const data = filterDataByArrayConfig(result, configWithStaticPageLabel);

    const newData = data.map((item: any) => { 
      return {
        [item.key]: { ...item.value }
      }
    });
    
    yield put(ConfigAction.getStaticPageConfigSuccess({staticConfigLoading: false, value: newData}));

  } catch (error) {
    yield put(BaseAction.errorHandling({
      message: `GET_STATIC_LANDING_PAGE_CONFIG ${error}`
    }));
  }
}

export function* getNavMenuConfig(action: any): any {
  try {
    const { key, label } = action;
    const data = yield call(AppService.getValueConfigAzure, key, label);
    if (data) {
      yield put(ConfigAction.getNavMenuConfigSuccess(data));
    }
  } catch (error) {
    yield put(
      BaseAction.errorHandling({
        message: `GET_NAV_MENU_CONFIG ${error}`,
      }),
    );
  }
}

export const watchConfig = [
  takeLatest(ConfigTypes.GET_GENERAL_CONFIG, getGeneralConfig),
  takeLatest(ConfigTypes.GET_NOTIFICATION_CONFIG, getNotificationConfig),
  takeLatest(ConfigTypes.GET_STATIC_PAGE_CONFIG, getStaticPageConfig),
  takeLatest(ConfigTypes.GET_NAV_MENU_CONFIG, getNavMenuConfig),
]
